export const OPCIONES = [{
    body: {
        paddingTop: 25,
        paddingBottom: 30,
        paddingLeft: 0,
        paddingRight: 10,
    },
    section: {
        position:"relative",
        width: "100%",
        height: "90vh",
        border: "1px solid #000"
    },
    row: {
        flexDirection: 'row'
    },
    
    /*------------------------------*/
    materia: {
        textAlign: 'center',
        paddingTop: 5,
    },

    textPeq: {
        fontSize: 8,
        marginBottom: 5,
        textAlign: 'left',
        fontFamily: 'Times-Roman'
    },
    background: {
        /* backgroundColor: "#aeaeae", */
        backgroundColor: "#eee",
    },

    /*------------------------------*/

    col1: {
        fontSize: 8,
        textAlign: 'left',
        width: 150,
        border: 0.8,
    },
    col2: {
        marginLeft: -1,
        fontSize: 6,
        textAlign: 'center',
        width: 30,
        border: 0.8,
    },
    col3: {
        marginLeft: -1,
        fontSize: 6,
        textAlign: 'center',
        width: 70,
        border: 0.8,
    },
    col4: {
        marginLeft: -1,
        fontSize: 8,
        textAlign: 'center',
        width: 80,
        border: 0.8,
    },
    col5: {
        marginLeft: -1,
        fontSize: 8,
        textAlign: 'center',
        width: 50,
        border: 0.8,
    },
    col6: {
        marginLeft: -1,
        fontSize: 6,
        textAlign: 'center',
        width: 80,
        border: 0.8,
    },
    col7: {
        marginLeft: 34,
        fontSize: 10,
        textAlign: 'center',
        width: 213,
    },
    col8: {
        marginLeft: -1,
        fontSize: 8,
        textAlign: 'right',
        width: 80,
        border: 0.8,
    },
    col9: {
        marginLeft: -1,
        fontSize: 8,
        textAlign: 'center',
        width: 81,
        border: 0.8,
    },
    col10: {
        marginLeft: -1,
        fontSize: 8,
        textAlign: 'center',
        width: 82,
        border: 0.8,
    },
    col11: {
        marginLeft: 34,
        fontSize: 10,
        textAlign: 'right',
        width: 292,
        border: 0.8,
    },
    col12: {
        marginLeft: 34,
        fontSize: 10,
        textAlign: 'center',
        width: 292,
        border: 0.8,
    },
    col13: {
        marginLeft: -1,
        fontSize: 6,
        textAlign: 'left',
        width: 101,
        border: 0.8,
    },
    col14: {
        marginLeft: -1,
        fontSize: 6,
        textAlign: 'left',
        width: 63,
        border: 0.8,
    },
    col15: {
        marginLeft: -1,
        fontSize: 10,
        textAlign: 'center',
        width: 484,
        border: 0.8,
    },
    col16: {
        fontSize: 10,
        textAlign: 'center',
        width: 130,
        borderLeft: 0.8,
        borderRight: 0.8,
        borderTop: 0.8,
    },
    col17: {
        fontSize: 8,
        textAlign: 'right',
        width: 130,
        borderLeft: 0.8,
        borderRight: 0.8,
    },
    col18: {
        fontSize: 8,
        textAlign: 'right',
        width: 130,
        borderLeft: 0.8,
        borderRight: 0.8,
        borderBottom: 0.8,
    },
    col19: {
        marginLeft: -1,
        fontSize: 8,
        textAlign: 'center',
        width: 162,
        border: 0.8,
    },
    col20: {
        marginLeft: -1,
        fontSize: 8,
        textAlign: 'center',
        width: 121,
        border: 0.8,
    },
    col21: {
        marginLeft: -1,
        fontSize: 8,
        textAlign: 'center',
        width: 245,
        border: 0.8,
    },
    /*------------------------------*/
    colContent40: {
        paddingHorizontal: 10,
        width: "15%"
    },
    logo: {
        height: 50,
        width:"auto",
        padding:0,
        marginLeft: 20,
        marginTop: -8
    },
}];


// WEBPACK FOOTER //
// ./src/components/Reportes/Styles/StylesAsistencia.jsx